export enum Steps {
	ZoneSettings = 0,
	Location = 1,
	NetworkConfig = 2,
	Confirmation = 3,
}
